import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { useAuth, dashboardHomeFor } from "@/contexts/AuthContext";
import { toast } from "sonner";
import { ShieldCheck, ArrowRight } from "lucide-react";

export default function AccountResetPassword() {
  const navigate = useNavigate();
  const { user, checkAuth } = useAuth();
  const [form, setForm] = useState({ new_password: "", confirm: "" });
  const [submitting, setSubmitting] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (form.new_password.length < 6) { toast.error("Min 6 characters"); return; }
    if (form.new_password !== form.confirm) { toast.error("Passwords don't match"); return; }
    setSubmitting(true);
    try {
      await api.post("/auth/reset-password", { new_password: form.new_password });
      toast.success("Password updated — welcome aboard!");
      await checkAuth?.();
      navigate(dashboardHomeFor(user?.role));
    } catch (e) {
      toast.error(e?.response?.data?.detail || "Failed");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="min-h-screen bg-kb-bg flex items-center justify-center px-6" data-testid="reset-password-page">
      <form onSubmit={submit} className="w-full max-w-md kb-card p-8">
        <ShieldCheck className="w-10 h-10 text-kb-primary" strokeWidth={1.5} />
        <h1 className="font-serif text-3xl text-kb-ink mt-4 leading-tight">Set a new <em className="italic text-kb-primary">password</em>.</h1>
        <p className="text-sm text-kb-ink-muted mt-2">
          Your account was created by your institution with a temporary password. Set a permanent one to continue.
        </p>
        <div className="mt-6 space-y-4">
          <div>
            <label className="kb-mono text-[10px] uppercase tracking-[0.2em] text-kb-ink-muted">New password</label>
            <input type="password" required minLength={6} className="kb-input mt-1.5"
              value={form.new_password} onChange={(e) => setForm({ ...form, new_password: e.target.value })}
              data-testid="reset-new-password-input" />
          </div>
          <div>
            <label className="kb-mono text-[10px] uppercase tracking-[0.2em] text-kb-ink-muted">Confirm password</label>
            <input type="password" required minLength={6} className="kb-input mt-1.5"
              value={form.confirm} onChange={(e) => setForm({ ...form, confirm: e.target.value })}
              data-testid="reset-confirm-password-input" />
          </div>
        </div>
        <button type="submit" disabled={submitting} className="kb-btn-primary w-full justify-center mt-6" data-testid="reset-submit-btn">
          {submitting ? "Saving…" : (<>Set password <ArrowRight className="w-4 h-4" /></>)}
        </button>
      </form>
    </div>
  );
}
